import { Card, Container } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDuelList } from 'src/hooks/dashboard/useDuelList';
import { MediaRewardsTableBreadcrumb, MediaRewardsTableRow, MediaRewardsTableToolbar } from 'src/sections/@dashboard/mediaRewards';
import Page from '../../components/Page';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import useTable from '../../hooks/useTable';
import GeneralFiltersAccordionWrapper from 'src/components/general/GeneralFiltersAccordionWrapper';
import { GeneralTable, GeneralTableWithDragAndDrop } from 'src/components/general';
import { DUEL_LIST_TABLE_HEAD, MEDIA_REWARDS_LIST_TABLE_HEAD } from 'src/constants/tableHeads';
import { DuelTableRow } from 'src/sections/@dashboard/duels';
import { useMediaRewards } from 'src/hooks/dashboard/useMediaRewards';

// ----------------------------------------------------------------------

export default function MediaRewards() {
  const { projectId } = useParams();

  const useTableOptions = useTable();
  const { page, selected, setSelected, onChangePage } = useTableOptions;

  const [applicationDetails] = useLocalStorage('applicationDetails');
  const [duelListFilters] = useLocalStorage('duelListFilters');

  const [selectedRow, setSelectedRow] = useState();
  const [isOpenLeaderboardModal, setIsOpenLeaderboardModal] = useState(false);

  const [filterItems, setFilterItems] = useState({
    AppID: +projectId,
    Title: duelListFilters?.Title || '',
    IsActive: duelListFilters?.IsActive || -1,
  });

  const { tableData, isLoading, deleteLoading, handleDeleteRow, handleEditRow, openConfirmDelete, setOpenConfirmDelete } = useMediaRewards({
    page,
    projectId,
    selected,
    setSelected,
    filterItems,
  });

  return (
    <Page title={`پاداش مشاهده ویدیوهای محصول ${applicationDetails?.ApplicationTitle}`}>
      <Container maxWidth={false}>
        <MediaRewardsTableBreadcrumb applicationDetails={applicationDetails} />
        <Card>
          {/* <GeneralFiltersAccordionWrapper>
            <MediaRewardsTableToolbar setFilterItems={setFilterItems} onChangePage={onChangePage} />
          </GeneralFiltersAccordionWrapper> */}

          <GeneralTable
            tableContainerSX={{ position: 'relative', maxHeight: { sx: 'calc(100dvh - 250px)', lg: 'calc(100dvh - 180px)' } }}
            rowID="MediaRewards"
            tableData={tableData}
            headLabel={MEDIA_REWARDS_LIST_TABLE_HEAD}
            isLoading={isLoading}
            isDeleteLoading={deleteLoading}
            onEditRow={handleEditRow}
            CustomTableRow={MediaRewardsTableRow}
            openConfirmDelete={openConfirmDelete}
            setOpenConfirmDelete={setOpenConfirmDelete}
            useTableOptions={useTableOptions}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            label={['پاداش', 'پاداش ها']}
            onDeleteRowHandler={handleDeleteRow}
          />
        </Card>
      </Container>

      {/* <DialogAnimate open={isOpenLeaderboardModal} onClose={() => setIsOpenLeaderboardModal(false)} maxWidth={'md'}>
        <DialogTitle sx={{ textAlign: 'center', mb: 2 }}>{`فهرست رتبه بندی`}</DialogTitle>
        <div style={{ maxHeight: '80vh' }}>
          <DuelLeaderboard selectedDuelId={selectedRow?.DuelID} />
        </div>
      </DialogAnimate> */}
    </Page>
  );
}
